/**
 * Decide how to locate the User login row from a Filter Students directory item.
 * Staff rows already use User.id; students are keyed by VE/Student id.
 */

export function resolveDirectoryPasswordTarget(row) {
  const type = String(row?.userType || row?.role || '')
    .trim()
    .toLowerCase();
  if (type && type !== 'student') {
    return { ok: true, userId: row.id };
  }
  const email = String(row?.emailAddress || row?.email || '').trim();
  if (!email) {
    return {
      ok: false,
      error: 'This user has no email, so the password cannot be changed.',
    };
  }
  return { ok: true, email };
}
